// extracted by mini-css-extract-plugin
export var base = "_4u-0";
export var updateBanner = "_4u-1";